import { Component, OnInit } from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Inject } from '@angular/core';
import { Application } from '../../../../models/application';
import { ApplicationDataService } from '../../../../../services/application.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-duplicate-app-dialog',
  templateUrl: './duplicate-app-dialog.component.html',
  styleUrls: ['./duplicate-app-dialog.component.css']
})
export class DuplicateAppDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: Application, private applicationService: ApplicationDataService, private router: Router) { }

  ngOnInit(): void {
    console.log(this.data);
  }

  continueApplication() {
    if (this.data.RentalApplicationKey !== 0) {
      localStorage.setItem('YardiKey', this.data.YardiKey);
      localStorage.removeItem('SelectedProperty');
      localStorage.removeItem('hasRentableItems');
      localStorage.setItem('RentalApplicationKey', this.data.RentalApplicationKey.toString());

      if (this.data.UnitCode != null) {
        localStorage.setItem('mfunitcode', this.data.UnitCode);
      }

      if (this.data.RentalAppStatus.toUpperCase() !== 'DRAFT' && this.data.RentalAppStatus.toUpperCase() !== 'WAIT LIST') {
        localStorage.removeItem('RentalApplicationKey');
        this.router.navigate(['/application/documents']);
      }
      else if (this.data.RentalAppStatus === 'WAIT LIST') {
        this.applicationService.checkPropertyWaitList(this.data.RentalApplicationKey, false)
          .subscribe(res => this.onContinueWaitListCheck(res), err => this.applicationService.handleError(err));
      } 
      else {
        localStorage.setItem('RentalApplicantKey', this.data.CurrentUserApplicantKey.toString());
        location.href = '/application/basic';
      }
    }
  }

  onContinueWaitListCheck(res: boolean) {
    if (res == false) {
      localStorage.setItem('RentalApplicantKey', this.data.CurrentUserApplicantKey.toString());
      location.href = '/application/basic';
    }
    else {
      localStorage.removeItem('RentalApplicationKey');
      this.router.navigate(['/application/documents']);
    }
  }
}
